import styled from "styled-components"

import BaseLink from "@irati/ui/src/Link"
import BaseCircledConnector from "@irati/ui/src/CircledConnector"
import {perkbox, greys} from "@irati/ui/src/global/colors"
import {Body} from "@irati/ui/src/Typography"

export const Link = styled(BaseLink)`
  font-size: 14px;
`

export const CircledConnector = styled(BaseCircledConnector)`
  display: inline-block;
  text-align: left;
  margin-bottom: 30px;
`

export const DownloadCsvText = styled.div`
  color: ${perkbox.blue};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const RecapContainer = styled.div`
  background-color: ${greys.lightest};
  border-radius: 10px;
  padding: 15px;
  margin-top: 30px;
`

export const List = styled.ul`
  margin-top: 15px;
  padding-left: 15px;
`

export const ChooseCountryText = styled(Body)`
  color: ${({theme}) => `${theme.colors.tertiary.o_400}`};
`
